import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { withTheme } from 'styled-components';
import { PolicyOverlay } from './policyOverlay.component';
import { selectCurrentExperience } from '../../../modules/experience';
import { selectIsPolicyVisible, OverlayActions, selectIsOverlayStandalone } from '../../../modules/overlay';
import { selectCancellationPolicy } from '../../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
  isPolicyVisible: selectIsPolicyVisible,
  isPolicyStandalone: selectIsOverlayStandalone,
  cancellationPolicy: selectCancellationPolicy,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showPolicy: OverlayActions.showPolicy,
      hidePolicy: OverlayActions.hideOverlay,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withTheme
)(PolicyOverlay);
